import { Box, Button, FormControl, IconButton, TextField, Typography } from '@mui/material'
import DeleteIcon from '@mui/icons-material/Delete'
import { AppDispatch, RootState } from '../../store/store'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { useDeleteContactMutation, useGetCompanyContactsQuery } from '../../store/api/backoffice/backofficeContactApi'
import {
	BackofficeCompanyContactsData,
	handleContacts,
} from '../../store/slices/backoffice/backofficeCompanyContactsSlice'
import { useEffect } from 'react'
import { filterContactForDelete } from '../../utils/contact-filter'

function BackOfficeContacts() {
	const location = useLocation()
	const dispatch = useDispatch<AppDispatch>()
	const { refetch } = useGetCompanyContactsQuery(location.state.companyDatabaseId)
	const companyContacts = useSelector((state: RootState) => state.backofficeCompanyContacts)
	const [deleteContact] = useDeleteContactMutation()

	const regexNoCharSymb = /[a-zA-Z$&+,:;=?@#|'<>-^*()%!-çªº*]/
	const regexNoSymb = /[$&+,:;=?@#|'<>-^*()%!]/

	const handleAddContact = () => {
		dispatch(
			handleContacts({
				...companyContacts,
				data: [
					...companyContacts.data,
					{ contactName: null, contactTitle: null, contactPhone: null, contactEmail: null },
				],
			}),
		)
	}

	const handleDeleteContact = (index: number) => {
		const copyContactsData = [...companyContacts.data]
		const contactForDeletion = filterContactForDelete(copyContactsData, companyContacts.data[index].companyContactId)
		copyContactsData.splice(index, 1)
		dispatch(handleContacts({ ...companyContacts, data: copyContactsData }))
		deleteContact({ companyContactId: contactForDeletion })
	}

	const handleContactNameChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, index: number) => {
		if (regexNoSymb.test(event.target.value)) {
			event.preventDefault()
		} else {
			const copyContact: BackofficeCompanyContactsData = {
				...companyContacts.data[index],
				contactName: event.target.value,
			}
			const copyContacts = [...companyContacts.data]
			copyContacts[index] = copyContact
			dispatch(handleContacts({ ...companyContacts, data: [...copyContacts] }))
		}
	}

	const handleContactTitleChange = (
		event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
		index: number,
	) => {
		if (regexNoSymb.test(event.target.value)) {
			event.preventDefault()
		} else {
			const copyContact: BackofficeCompanyContactsData = {
				...companyContacts.data[index],
				contactTitle: event.target.value,
			}
			const copyContacts = [...companyContacts.data]
			copyContacts[index] = copyContact
			dispatch(handleContacts({ ...companyContacts, data: [...copyContacts] }))
		}
	}

	const handleContactEmailChange = (
		event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
		index: number,
	) => {
		const copyContact: BackofficeCompanyContactsData = {
			...companyContacts.data[index],
			contactEmail: event.target.value,
		}
		const copyContacts = [...companyContacts.data]
		copyContacts[index] = copyContact
		dispatch(handleContacts({ ...companyContacts, data: [...copyContacts] }))
	}

	const handleContactPhoneChange = (
		event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
		index: number,
	) => {
		if (regexNoCharSymb.test(event.target.value)) {
			event.preventDefault()
		} else {
			const copyContact: BackofficeCompanyContactsData = {
				...companyContacts.data[index],
				contactPhone: event.target.value,
			}
			const copyContacts = [...companyContacts.data]
			copyContacts[index] = copyContact
			dispatch(handleContacts({ ...companyContacts, data: [...copyContacts] }))
		}
	}

	useEffect(() => {
		refetch()
	}, [location.state.companyDatabaseId])

	return (
		<>
			<Typography
				sx={{ paddingBlock: '0.2rem' }}
				variant='h6'
			>
				Contactos
			</Typography>
			{companyContacts.data
				? companyContacts.data.map((item: BackofficeCompanyContactsData, index: number) => {
						return (
							<Box
								key={item.companyContactId ?? index}
								sx={{ display: 'flex', flexWrap: '', margin: '0.2rem 0rem' }}
							>
								<FormControl sx={{ minWidth: 120, width: '100%', display: 'flex' }}>
									<Box sx={{ display: 'flex', width: '100%' }}>
										<TextField
											size='small'
											value={item.contactName}
											onChange={event => handleContactNameChange(event, index)}
											label='Nome'
											variant='outlined'
											sx={{ margin: '0.2rem', width: '25%' }}
										/>
										<TextField
											size='small'
											value={item.contactTitle}
											onChange={event => handleContactTitleChange(event, index)}
											label='Título'
											variant='outlined'
											sx={{ margin: '0.2rem', width: '25%' }}
										/>
										<TextField
											size='small'
											value={item.contactEmail}
											onChange={event => handleContactEmailChange(event, index)}
											label='Email'
											variant='outlined'
											sx={{ margin: '0.2rem', width: '25%' }}
										/>
										<TextField
											size='small'
											value={item.contactPhone}
											onChange={event => handleContactPhoneChange(event, index)}
											label='Telefone'
											variant='outlined'
											sx={{ margin: '0.2rem', width: '25%' }}
										/>
									</Box>
								</FormControl>
								<IconButton
									sx={{ marginBlockStart: '0.9rem', width: '0.5rem', height: '1.5rem' }}
									onClick={() => handleDeleteContact(index)}
									aria-label={`delete contact ${item.contactName ?? ''}`}
								>
									<DeleteIcon sx={{ color: 'var(--primary)' }} />
								</IconButton>
							</Box>
						)
					})
				: []}
			<Box sx={{ display: 'flex', justifyContent: 'flex-start' }}>
				<Button
					onClick={handleAddContact}
					variant='text'
				>
					Adicionar Contacto +
				</Button>
			</Box>
		</>
	)
}

export default BackOfficeContacts
